import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const growthBook = defineConnector({
  identifier: "growthBook",
  name: "GrowthBook",
  tagLine: "Open-source feature flags and experiments",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl || "https://api.growthbook.io"),
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [GrowthBook](https://app.growthbook.io/settings/keys), open **Settings › API Keys** and create a secret key.",
        },
      ],
    },
    {
      title: "Enter your GrowthBook details",
      items: [
        {
          kind: "baseUrl",
          label: "API URL",
          placeholder: "https://api.growthbook.io",
          helperText:
            "Leave blank for GrowthBook Cloud, or use your self-hosted API host.",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "Secret key",
          placeholder: "secret_...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://api.growthbook.io"}/api/v1/features?limit=1`,
  },
});
